import { Module } from "vuex";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { AlarmMaskingState } from "./types";
import { RootState } from "../types";
import { getDefaultState } from "./state";

export const state: AlarmMaskingState = getDefaultState();

export const alarmMasking: Module<AlarmMaskingState, RootState> = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
